import { createAction, props } from '@ngrx/store';
import { IOfferState } from './offer.state';

export const initOfferAction = createAction('[popup Offer] popup Offer');

export const setOfferAction = createAction(
  '[popup Offer] set data',
  props<IOfferState>()
);
